import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import {
  MessageNotification,
  ProjectStatusUpdateNotification
} from '../models/messageNotification.model';
import { AuthService } from '../../core/auth/auth.service';
import { HotToastService } from '@ngxpert/hot-toast';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationListenerService {
  private hubConnectionBuilder: HubConnection;
  private readonly _projectStatusUpdated = new Subject<ProjectStatusUpdateNotification>();

  readonly projectStatusUpdated$ = this._projectStatusUpdated.asObservable();

  constructor(
    private readonly _authService: AuthService,
    private readonly _toastService: HotToastService
  ) {}

  listenToNotifyer() {
    let urlSignalR = environment.RESOURCES_API + 'notify';
    this.hubConnectionBuilder = new HubConnectionBuilder()
      .withUrl(urlSignalR)
      .withAutomaticReconnect()
      .build();
    this.hubConnectionBuilder
      .start()
      .then(() => console.log('Connection started.......!'))
      .catch(err => {
        console.log('Error while connect with server: ' + err);
      });

    this.hubConnectionBuilder.onclose(() => {
      this.hubConnectionBuilder.start().then(() => console.log('Connection started.......!'));
    });

    this.hubConnectionBuilder.on('BroadcastMessage', (result: MessageNotification) => {
      switch (result.type) {
        case 'RoleUpdate':
        case 'UpdateRole':
          this.reloadRole();
          break;
        case 'ProjectStatusUpdate':
          this.notifyProjectStatusUpdate(result);
          break;
      }
    });
  }

  private notifyProjectStatusUpdate(notification: MessageNotification): void {
    if (!notification.entityData) {
      return;
    }

    try {
      const data = JSON.parse(notification.entityData);
      const projectId = data.projectId ?? data.ProjectId;
      const newStatus = data.newStatus ?? data.NewStatus;

      if (projectId) {
        this._projectStatusUpdated.next({ projectId, newStatus });
      }
    } catch (error) {
      console.error('Invalid project status update notification payload', error);
    }
  }

  reloadRole() {
    const token = this._authService.decodeJwt(localStorage.getItem('accessToken'));
    this._authService.getUserDetails(token).subscribe({
      next: user => {
        this._toastService.success('Votre rôle a été mis à jour avec succès');
      },
      error: error => {
        console.log('Error while getting user details: ' + error);
      }
    });
  }
}
